import { FaArrowDown, FaArrowUp } from 'react-icons/fa6';
import { IoMdRemove } from 'react-icons/io';
import { ImBlocked } from 'react-icons/im';
import React from 'react';

export const getIconByStatus = (status) => {
    switch (status) {
        case 'completed':
            return <FaArrowUp />;
        case 'agreement':
            return <IoMdRemove />;
        case 'debtors':
            return <FaArrowDown />;
        case 'canceled':
            return <ImBlocked />;
        default:
            return <div />;
    }
};
